import React from 'react';
import {connect} from 'react-redux';

const authorization = (Component) => {
  
  class HOC extends React.Component {
    
    render() {
      if (this.props.logged) {
        return (
          <Component/>
        )
      } else {
        return (
		<React.Fragment/>				
        )
      }
    }
  }
  
  function mapStateToProps(state) {
    return {
      logged: state.auth.logged
    }
  }
  
  return connect(mapStateToProps)(HOC)
  
};

export default authorization;